import { render, staticRenderFns } from "./ConfirmProtocolSummarizationPopup.view.vue?vue&type=template&id=4cb0d0d1&"
import script from "./ConfirmProtocolSummarizationPopup.view.vue?vue&type=script&lang=js&"
export * from "./ConfirmProtocolSummarizationPopup.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb0d0d1')) {
      api.createRecord('4cb0d0d1', component.options)
    } else {
      api.reload('4cb0d0d1', component.options)
    }
    module.hot.accept("./ConfirmProtocolSummarizationPopup.view.vue?vue&type=template&id=4cb0d0d1&", function () {
      api.rerender('4cb0d0d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/protocol/ConfirmProtocolSummarizationPopup.view.vue"
export default component.exports